// apolo/src/lib/loop/toolResultClearing.js — harness-uplift-r2 E4.
// @arch:pure-engine
//
// Anthropic context-engineering "safest lightest touch form of compaction":
// once a tool result is deep in history and already consumed, its raw body adds
// tokens without value. This clears the BODY of older tool results (keeping the
// last keepLastN verbatim) while preserving the tool CALL identity and every
// non-tool message. Pure, idempotent, never mutates input, never throws.
//
// Interaction note (wiring): only run this on a NON-cacheable block — clearing a
// result rewrites the prefix and would invalidate the proven cache boundary.

export const CLEARED_PLACEHOLDER = '[tool result cleared]';

function isToolRow(m) {
  return m && typeof m === 'object' && m.role === 'tool';
}

/**
 * @param {Array<object>} history
 * @param {{ keepLastN?: number }} [opts]
 * @returns {Array<object>}
 */
export function clearConsumedResults(history, opts = {}) {
  try {
    if (!Array.isArray(history)) return [];
    const keepLastN = Number.isFinite(opts.keepLastN) ? Math.max(0, opts.keepLastN) : 3;

    // Index of the (keepLastN)-th tool row from the end: tool rows at or after it
    // are kept verbatim; older tool rows get their body cleared.
    const toolIdxs = [];
    for (let i = 0; i < history.length; i++) if (isToolRow(history[i])) toolIdxs.push(i);
    const keepFromIdx = toolIdxs.length > keepLastN ? toolIdxs[toolIdxs.length - keepLastN] : -1;

    return history.map((m, i) => {
      if (!isToolRow(m)) return m;
      if (keepFromIdx === -1 || i >= keepFromIdx) return m; // recent → verbatim
      if (m.content === CLEARED_PLACEHOLDER) return m; // idempotent
      return { ...m, content: CLEARED_PLACEHOLDER };
    });
  } catch {
    return Array.isArray(history) ? history : [];
  }
}
